import React, { Component } from 'react'
import { Store, Creators, ActiveStore } from 'model';
import { Container } from 'flux/utils';
import { ActiveFilters } from './filters';
import CurrentFilters from './CurrentFilters';

function App({ recommendations, onRefresh, loading }) {

	const items = <ActiveFilters filters={recommendations} onClick={ Creators.addFilter } />

	var view = '';

	if(loading) {
		view = <div>loading</div>;
	} else {
		view = <div>
			<div><a href="#" onClick={() => { onRefresh('pri'); }}>osvježi "PRI"</a></div>
			<div><a href="#" onClick={() => { onRefresh('prog'); }}>osvježi "PROG"</a></div>
			{items}
		</div>
	}

	return <div>
		<h1>Radi ko urica</h1>
		{ view }
		<h2>Aktivni filteri</h2>
		<CurrentFilters />
	</div>;
}

function getStores() {
	return [Store];
}

function calcState() {
	var state = Store.getState();

	return {
		recommendations: state.recommendations,
		onRefresh: Creators.findRecommendations,
		loading: state.loading
	};
}

export default Container.createFunctional(App, getStores, calcState)





// WEBPACK FOOTER //
// ./src/modules/app/App.js